import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { Toaster } from './components/ui/sonner';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import OnboardingWalkthrough from './components/OnboardingWalkthrough';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Signup from './pages/Signup';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import Pricing from './pages/Pricing';
import Reviews from './pages/Reviews';
import About from './pages/About';
import ContentLibrary from './pages/ContentLibrary';
import Community from './pages/Community';
import Coaching from './pages/Coaching';
import PaymentSuccess from './pages/PaymentSuccess';
import Success from './pages/Success';
import Cancel from './pages/Cancel';
import Referral from './pages/Referral';
import Admin from './pages/Admin';
import AdminReferrals from './pages/AdminReferrals';
import MembershipTerms from './pages/MembershipTerms';
import CourseTerms from './pages/CourseTerms';
import AccountDetails from './pages/AccountDetails';
import FAQ from './pages/FAQ';
import NotFound from './pages/NotFound';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="min-h-screen flex flex-col">
          <Navbar />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/reviews" element={<Reviews />} />
              <Route path="/about" element={<About />} />
              <Route path="/referral" element={<Referral />} />
              <Route path="/terms/membership" element={<MembershipTerms />} />
              <Route path="/terms/course" element={<CourseTerms />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/payment-success" element={<PaymentSuccess />} />
              <Route path="/success" element={<Success />} />
              <Route path="/cancel" element={<Cancel />} />
              <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/content" element={<ProtectedRoute><ContentLibrary /></ProtectedRoute>} />
              <Route path="/community" element={<ProtectedRoute><Community /></ProtectedRoute>} />
              <Route path="/coaching" element={<ProtectedRoute><Coaching /></ProtectedRoute>} />
              <Route path="/account" element={<ProtectedRoute><AccountDetails /></ProtectedRoute>} />
              <Route path="/admin" element={<AdminRoute><Admin /></AdminRoute>} />
              <Route path="/admin/referrals" element={<AdminRoute><AdminReferrals /></AdminRoute>} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
        </div>
        <Toaster richColors position="top-center" />
        <OnboardingWalkthrough />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;